<template>
  <div>
    <report-base
      title="Bookings"
      table-class="analytics-tables--bookings"
      subject="booking"
      :items="bookings"
      :fields="fields"
      :is-loading="loading"
      @reload="loadData"
    />
  </div>
</template>

<script>
import AnalyticsMixin from './mixin';

export default {
  name: 'analytics-bookings',

  mixins: [
    AnalyticsMixin
  ],

  data() {
    return {
      bookings: [],
      fields: [
        {
          key: 'booking_name',
          label: 'Booking Name',
          sortable: true,
        },
        {
          key: 'booking_number',
          label: 'Booking Number',
          sortable: true,
          thStyle: 'width: 150px'
        },
        {
          key: 'booking_rooms',
          label: 'Room Number',
          sortable: false,
        },
        {
          key: 'booking_room_types',
          label: 'Room Category',
          sortable: false,
        },
        {
          key: 'check_in_at',
          label: 'Check-in',
          sortable: true,
          thStyle: 'width: 165px'
        },
        {
          key: 'check_out_at',
          label: 'Check-out',
          sortable: true,
          thStyle: 'width: 165px'
        },
        {
          key: 'unit_total',
          label: 'Accommodations',
          sortable: true,
          thStyle: 'width: 150px'
        },
        {
          key: 'item_total',
          label: 'Sales',
          sortable: true,
        },
        {
          key: 'sub_total',
          label: 'Subtotal',
          sortable: true,
        },
        {
          key: 'discounts',
          label: 'Discount',
          sortable: true,
        },
        {
          key: 'refunded',
          label: 'Refunds',
          sortable: true,
        },
        {
          key: 'taxes_total',
          label: 'Taxes & Fees',
          sortable: true,
        },
        {
          key: 'tips',
          label: 'Tips',
          sortable: true,
        },
        {
          key: 'grand_total',
          label: 'Total',
          sortable: true,
        },
        {
          key: 'paid_total',
          label: 'Payments',
          sortable: true,
        },
        {
          key: 'balance_due',
          label: 'Balance',
          sortable: true,
        },
      ]
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    loadData () {
      this.loading = true;

      this.fetchData('booking')
        .then(res => {
          this.bookings = res.data
            .map(booking_ => {
              return {
                booking_name: booking_.booking_name,
                booking_number: booking_.booking_number,
                booking_room_types: booking_.booking_room_types,
                booking_rooms: booking_.booking_rooms,
                check_in_at: this.formatDate(booking_.check_in_at),
                check_out_at: this.formatDate(booking_.check_out_at),
                unit_total: this.formatMoney(booking_.unit_total),
                item_total: this.formatMoney(booking_.item_total),
                sub_total: this.formatMoney(booking_.sub_total),
                discounts: this.formatMoney(booking_.discounts),
                refunded: this.formatMoney(booking_.refunded),
                taxes_total: this.formatMoney(booking_.taxes_total),
                tips: this.formatMoney(booking_.tips),
                paid_total: this.formatMoney(booking_.paid_total),
                grand_total: this.formatMoney(booking_.grand_total, 2, true),
                balance_due: this.formatMoney(booking_.balance_due, 2, true)
              }
            })

        })
        .catch(err => {
          this.errorNotification('Failed to fetch booking report!');
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
  .analytics-tables--bookings {
    table {
      min-width: 2200px !important;
    }
  }
</style>
